import * as theme from '@/theme';

const removePrefixesFromFiles = new Set(['global']);

export function themeToCSSVariables(
  themeData: Record<string, any>,
  prefix = ''
): string[] {
  return Object.entries(themeData).reduce<string[]>((acc, curr) => {
    const [key, value] = curr;

    if (typeof value === 'object') {
      return [
        ...acc,
        ...themeToCSSVariables(
          value,
          removePrefixesFromFiles.has(prefix) ? undefined : key
        )
      ];
    }

    const variable = removePrefixesFromFiles.has(prefix)
      ? `--${key}: ${value}`
      : `--${prefix}-${key}: ${value}`;

    return [...acc, variable];
  }, []);
}

export function setCSSVariables() {
  for (const variable of themeToCSSVariables(theme)) {
    const [property, value] = variable.split(':');

    document.documentElement.style.setProperty(property, value);
  }
}
